import React, { useEffect, useState } from "react";
import { GoogleMap, Marker, useLoadScript } from "@react-google-maps/api";
import io from "socket.io-client";

const socket = io("http://192.168.0.221:5000", { transports: ["websocket"] });

const mapContainerStyle = {
  width: "100vw",
  height: "100vh",
};

const defaultCenter = { lat: -23.55052, lng: -46.633308 }; // Localização inicial (São Paulo, por exemplo)

export default function LocationViewer() {
  const [location, setLocation] = useState(null);

  // Carregar Google Maps com a API Key
  const { isLoaded } = useLoadScript({
    googleMapsApiKey: "AIzaSyC_edobEBxqd1TxpE--QDUcJCxgQVEY_lE", // 🔴 Substitua pela sua chave de API
  });

  useEffect(() => {
    socket.on("locationUpdate", (data) => {
      console.log("Localização recebida:", data);
      setLocation({ lat: data.latitude, lng: data.longitude });
    });

    return () => {
      socket.off("locationUpdate");
    };
  }, []);

  if (!isLoaded) return <p>Carregando mapa...</p>;

  return (
    <GoogleMap
      mapContainerStyle={mapContainerStyle}
      zoom={15}
      center={location || defaultCenter}
    >
      {location && <Marker position={location} />}
    </GoogleMap>
  );
}
